<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="center"><a id="pagev"></a><em>To ACG, my favorite taste tester.<br/>Thank you for always being hungry; for eating<br/>the good and the bad, the sweet and the spicy; and for<br/>turning a blind eye when things burn.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?8cc0dd86